export default __webpack_public_path__ + "static/media/drug-icon.0cef7542.svg";